import {PlayCircleOutlined} from '@ant-design/icons';
import styles from './newsOverview.module.scss';
import {
  Navigate,
  NavLink,
  Outlet,
  useLocation,
  useMatch,
  useResolvedPath,
} from 'react-router-dom';
import classnames from 'classnames/bind';
import {NavTabsEnum} from 'utils/constants';
import {useVisibleSubTabs} from 'utils/useVisibleSubTabs';

// A walkthrough of the news pipeline: websites, story activity and review.
const EXPLAINER_VIDEO_URL = 'https://nebula.dabafinance.com/view?m=EWQN1fTc4';

const NEWS_SUBTABS = [
  // {key: 'incoming-news', to: '/dashboard/news', name: 'Incoming News'},
  // {
  //   key: 'selected-news',
  //   to: '/dashboard/news/selected-news',
  //   name: 'Selected News',
  // },
  {
    key: 'website-news',
    to: '/dashboard/news/website-news',
    name: 'Website News',
  },
  {key: 'news-sources', to: '/dashboard/news/sources', name: 'News Sources'},
  // news-service puts Story activity's operations on the News websites
  // sub-tab and Review's on Website News, so these share those grants.
  {key: 'news-sources', to: '/dashboard/news/activity', name: 'Story activity'},
  {key: 'website-news', to: '/dashboard/news/review', name: 'Review'},
];

// Incoming News is retired, so /dashboard/news — the sidebar, the page search,
// old bookmarks — lands on the first tab this admin can see instead.
export const NewsLanding = () => {
  const {firstVisible} = useVisibleSubTabs(NavTabsEnum.News, NEWS_SUBTABS);
  return firstVisible ? <Navigate to={firstVisible.to} replace /> : null;
};

const NewsOverview = () => {
  // The video covers the pipeline tabs, not Website News.
  const showExplainer = !useLocation().pathname.includes('/website-news');
  const {visibleSubTabs} = useVisibleSubTabs(NavTabsEnum.News, NEWS_SUBTABS);

  const CustomLink = ({to, name}) => {
    const resolved = useResolvedPath(to);
    const match = useMatch({path: resolved.pathname, end: true});
    const cx = classnames.bind(styles);
    return (
      <NavLink className={cx('nav-link', match ? 'active-toggle' : '')} to={to}>
        <span>{name}</span>
      </NavLink>
    );
  };

  return (
    <div className={styles.root}>
      <div className={styles.titleRow}>
        <h1>News Administration</h1>
        {showExplainer && (
          <a
            className={styles.explainerLink}
            href={EXPLAINER_VIDEO_URL}
            target="_blank"
            rel="noopener noreferrer">
            <PlayCircleOutlined />
            Watch how it works
          </a>
        )}
      </div>
      <div className={styles.section}>
        <div className={styles.toggler}>
          {visibleSubTabs.map(tab => (
            <CustomLink key={tab.to} to={tab.to} name={tab.name} />
          ))}
        </div>
      </div>
      <section>
        <Outlet />
      </section>
    </div>
  );
};

export default NewsOverview;
